import React from "react";
import PropTypes from "prop-types";
import ImageItemsPanel from "./panels/ImageItemsPanel";
import AssessmentItemsPanel from "./panels/AssessmentItemsPanel";
import YoutubePanel from "./panels/YoutubePanel";
import BasicElementsPanel from "./panels/BasicElementsPanel";
import SmartElementsPanel from "./panels/SmartElementsPanel";
import ClickMenuPanel from "./panels/ClickMenuPanel";
import ShapesPanel from "./panels/ShapesPanel";
import SoundItemsPanel from "./panels/SoundItemsPanel";
import { ANIMATION_ITEMS } from "./data/animationItems";
import { ICON_ITEMS } from "./data/iconItems";
import { CHARACTER_ITEMS } from "./data/characterItems";

const ComponentsPanels = (props) => {
  const {
    libraryCategory,
    boxes,
    boxSelected,
    navItems,
    navItemSelected,
    containedViews,
    containedViewSelected,
    fileModalResult,
    onAddBox,
    onReturnToLayers,
    onReplacePluginFile,
    onSetLibraryCategory,
    isClm,
  } = props;

  // Shared panel wiring; adding keeps the menu open, replace-in-place closes it.
  const mediaProps = {
    boxes,
    navItems,
    navItemSelected,
    containedViews,
    containedViewSelected,
    fileModalResult,
    onBoxAdded: (...args) => onAddBox(...args),
    onElementSelected: (name, url) => {
      const replaceId = fileModalResult?.id;
      if (!replaceId || !url) return;
      onReplacePluginFile(replaceId, url, libraryCategory);
      onReturnToLayers();
      onSetLibraryCategory(null);
    },
    onClose: () => onSetLibraryCategory(null),
  };

  const elementProps = {
    boxes,
    boxSelected,
    isClm,
    navItems,
    navItemSelected,
    containedViews,
    containedViewSelected,
    onBoxAdded: (...args) => onAddBox(...args),
    onClose: () => onSetLibraryCategory(null),
  };

  if (libraryCategory === "BasicElements") {
    return <BasicElementsPanel {...elementProps} />;
  }

  if (libraryCategory === "SmartElements") {
    return <SmartElementsPanel {...elementProps} />;
  }

  if (libraryCategory === "ClickMenu") {
    return <ClickMenuPanel {...elementProps} />;
  }

  if (libraryCategory === "Shapes") {
    return <ShapesPanel {...elementProps} />;
  }

  if (libraryCategory === "Animations") {
    return (
      <ImageItemsPanel
        items={ANIMATION_ITEMS}
        cellSize={84}
        componentType="Animations"
        {...mediaProps}
      />
    );
  }

  if (libraryCategory === "Icons") {
    return (
      <ImageItemsPanel items={ICON_ITEMS} cellSize={64} componentType="Icons" {...mediaProps} />
    );
  }

  if (libraryCategory === "Characters") {
    return (
      <ImageItemsPanel
        items={CHARACTER_ITEMS}
        cellSize={80}
        ratio={4 / 3}
        componentType="Characters"
        {...mediaProps}
      />
    );
  }

  if (libraryCategory === "Youtube") {
    return <YoutubePanel {...mediaProps} />;
  }

  if (libraryCategory === "Sounds") {
    return <SoundItemsPanel {...mediaProps} />;
  }

  if (libraryCategory === "Assessments") {
    return (
      <AssessmentItemsPanel
        boxes={boxes}
        boxSelected={boxSelected}
        navItems={navItems}
        navItemSelected={navItemSelected}
        containedViews={containedViews}
        containedViewSelected={containedViewSelected}
        onBoxAdded={mediaProps.onBoxAdded}
        onClose={() => onSetLibraryCategory(null)}
      />
    );
  }

  return null;
};

ComponentsPanels.propTypes = {
  libraryCategory: PropTypes.string,
  boxes: PropTypes.object,
  boxSelected: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  navItems: PropTypes.object,
  navItemSelected: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  containedViews: PropTypes.object,
  containedViewSelected: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  fileModalResult: PropTypes.object,
  onAddBox: PropTypes.func,
  onReturnToLayers: PropTypes.func,
  onReplacePluginFile: PropTypes.func,
  onSetLibraryCategory: PropTypes.func,
  isClm: PropTypes.bool,
};

export default ComponentsPanels;
